export const SET_STEP = 'SET_STEP'
export const SET_MAPPING = 'SET_MAPPING'
export const SET_SCHEMAS = 'SET_SCHEMAS'
export const SET_TEMPLATES = 'SET_TEMPLATES'
export const SET_DELIMITER = 'SET_DELIMITER'
export const SET_MAPPING_ID = 'SET_MAPPING_ID'
export const SET_MAPPED_DATA = 'SET_MAPPED_DATA'
export const SET_SCHEMA_NAME = 'SET_SCHEMA_NAME'
export const SET_CORPORATE_ID = 'SET_CORPORATE_ID'
export const SET_ROWS_TO_SKIP = 'SET_ROWS_TO_SKIP'
export const SET_VISITED_STEP = 'SET_VISITED_STEP'
export const SET_TEMPLATE_NAME = 'SET_TEMPLATE_NAME'
export const SET_SCHEMA_COLUMNS = 'SET_SCHEMA_COLUMNS'
export const RESET_VISITED_STEP = 'RESET_VISITED_STEP'
export const SET_IS_SKIP_CHECKED = 'SET_IS_SKIP_CHECKED'
export const SET_FILE_DATA_ARRAY = 'SET_FILE_DATA_ARRAY'
export const SET_CSVDATA = 'SET_CSVDATA'
// export const SET_ADDRESS_ERROR = 'SET_ADDRESS_ERROR'
// export const SET_ADDRESS_APPROVED = 'SET_ADDRESS_APPROVED'
// export const SET_ADDRESS_DUPLICATE = 'SET_ADDRESS_DUPLICATE'



// WEBPACK FOOTER //
// ./src/store/modules/admin/import-data/types.js